{
  "infoCard": {
    "labels": {
      "aircraft": "Aircraft",
      "utilization": "Utilization",
      "trips": "Trips",
      "doorSize": "Door Size",
      "estTowTime": "Est. Tow Time",
      "estValue": "Est. Value",
      "total": "Total",
      "transients": "Transients",
      "dimensions": "Dimensions",
      "parameters": "Parameters"
    },
    "tooltips": {
      "aircraftCount": "# aircraft inside hangar / # aircraft wanted inside",
      "utilization": "Stacked aircraft utl. / All aircraft on screen utl. You can adjust how utilization is calculated in Settings > Configuration.",
      "towTime": "Estimated time it would take to tow every aircraft out of the hangar.",
      "tripsCount": "Active trips / Future trips assigned to this hangar",
      "estimatedValue": "Estimated daily revenue from your hangar.",
      "transientValue": "Revenue from overnight transient aircraft."
    },
    "units": {
      "perDay": " / day",
      "perMonth": " / mo"
    }
  },
  "customStackDialog": {
    "title": "Customize your Stack",
    "buttons": {
      "back": "Back",
      "runStack": "Run Stack"
    },
    "sections": {
      "spacingSOP": "Spacing SOP",
      "preferences": "Preferences"
    },
    "labels": {
      "horizontal": "Horizontal (ft)",
      "vertical": "Vertical (ft)",
      "leftWall": "Left Wall (ft)",
      "backWall": "Back Wall (ft)",
      "rightWall": "Right Wall (ft)",
      "towingEquipment": "Towing Equipment For Stack",
      "ignore": "Ignore?",
      "allowOverlap": "Allow Overlap",
      "ignoreNoseInOut": "Ignore Nose In/Out Preferences",
      "ignoreFrontBack": "Ignore Front/Back Preferences",
      "ignoreOutsideHangar": "Ignore Allow Outside Hangar Preferences",
      "cloudPrioritization": "Use Cloud Position Prioritization",
      "sampleSize": "Sample Size",
      "cornerStrategy": "Corner Strategy",
      "xyWeights": "XY Weights",
      "xWeight": "X",
      "yWeight": "Y",
      "densityThreshold": "3D Density Threshold"
    },
    "tooltips": {
      "spacingSOP": "Override SOPs. These will default to the SOPs set for your FBO.",
      "preferences": "Customize your stacking preferences. These will apply to every aircraft."
    },
    "descriptions": {
      "allowOverlap": "Allow the algorithm to overlap planes.",
      "ignoreNoseInOut": "Allow the algorithm to use your towing orientation preferences.",
      "ignoreFrontBack": "Allow the algorithm to use your front or back row preference.",
      "ignoreOutsideHangar": "Allow the algorithm to consider your \"ok to leave out\" preferences.",
      "cloudPrioritization": "Uses \"Cloud\" (ConvexHull) position prioritization to determine which positions to evaluate."
    }
  },
  "evaluatingStackDialog": {
    "titles": {
      "selectStack": "Select a Stack",
      "evaluating": "Evaluating Stack"
    },
    "progress": {
      "preparing": "Preparing for takeoff...",
      "scenariosEvaluated": "{{formattedCount}} scenarios evaluated"
    },
    "complete": {
      "modifyLink": "Try modifying your requirements.",
      "finishedMessage": "Finished Message"
    },
    "buttons": {
      "cancel": "Cancel Stack",
      "endEarly": "End Stacking Early"
    }
  },
  "runStack": {
    "buttons": {
      "autoStack": "AutoStack",
      "autoStackDev": "AutoStack Dev",
      "results": "Results",
      "cancel": "Cancel",
      "customizeStack": "Customize Stack",
      "runStack": "Run Stack"
    },
    "tooltips": {
      "autoStack": "AutoStack",
      "results": "Results"
    },
    "dialog": {
      "title": "AutoStack"
    },
    "alerts": {
      "lockReminder": "Remember to lock aircraft that should not be moved."
    }
  },
  "selectStackStrategy": {
    "common": {
      "notAvailable": "N/A",
      "noOverlap": "No Overlap"
    },
    "strategies": {
      "normal": {
        "title": "Normal",
        "description": "Day-to-day operations using SOPs."
      },
      "tight": {
        "title": "Tight",
        "description": "Optimized for maximum utilization."
      },
      "loose": {
        "title": "Loose",
        "description": "Optimized for easy towing, at the expense of utilization."
      },
      "custom": {
        "title": "Custom",
        "description": "Completely customize your stack preferences."
      }
    },
    "spacing": {
      "horizontal": "Horizontal: {{value}}",
      "overlapMin": "Overlap Min: {{value}}"
    }
  },
  "selectTowingEquipment": {
    "labels": {
      "towingEquipment": "Towing Equipment For Stack",
      "ignore": "Ignore?"
    }
  },
  "stackResult": {
    "utilization": "Utilization",
    "inside": "Inside",
    "outside": "Outside",
    "selectStack": "Select Stack",
    "flagPoorLayout": "Flag poor layout"
  },
  "hangarPrintLayout": {
    "aircraft": "Aircraft",
    "utilization": "Utilization",
    "estValue": "Est. Value",
    "estTowTime": "Est. Tow Time",
    "footer": {
      "automaticallyOptimizedBy": "Automatically optimized by",
      "contactInfo": "Contact us at www.airplx.com or peter@airplx.com."
    }
  }
}
